<template>
  <div class="scroll-con">
    <div class="banner-content">
      <img src="../assets/slogan.png" alt="" class="banner-content-title" />
      <img src="../assets/banner.png" alt="Banner Background" class="banner-content-bg" />
      <div class="banner-content-tip">
        今日投资者关心的热门话题:
        <span class="change" @click="getSuggestions">
          <i class="el-icon-refresh" style="margin: 0 8px"></i>换一批
        </span>
      </div>
    </div>
    <div class="quick-questions">
      <div
        class="item"
        v-for="(question, index) in quickQuestions"
        :key="index"
        type="text"
        size="small"
        @click="selectQuestion(question)"
      >
        {{ question }}
      </div>
    </div>
  </div>
</template>

<script>
import { knowledgeSuggestions } from '@/api';

export default {
  name: "DefaultBanner",
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      quickQuestions: [],
    };
  },
  mounted() {
    if (this.isLogin) {
      this.getSuggestions();
    }
  },
  watch: {
    isLogin(newVal) {
      if (newVal) {
        this.getSuggestions();
      }
    },
  },
  methods: {
    getSuggestions() {
      if (!this.isLogin) return;
      knowledgeSuggestions()
        .then(({ rows }) => {
          this.quickQuestions = rows;
        })
        .catch(() => {});
    },

    selectQuestion(question) {
      this.$emit("selectQuestion", question);
    },
  },
};
</script>

<style scoped lang="scss">
.scroll-con {
  height: calc(100% - 280px);
  overflow: auto;
}

.banner-content {
  width: 80%;
  position: relative;
  margin-left: 10%;

  &-bg {
    width: 100%;
  }

  &-title {
    width: 40%;
    position: absolute;
    top: 10%;
    left: 20%;
  }

  &-tip {
    width: 100%;
    height: 18%;
    position: absolute;
    word-break: break-all;
    bottom: 0;
    left: 3.8%;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #2b67e2;
    line-height: 22px;

    .change {
      cursor: pointer;
    }
  }
}

.quick-questions {
  width: 80%;
  margin: 34px auto 57px;
  display: flex;
  flex-wrap: wrap;
  padding-left: 35px;

  .item {
    margin-right: 35px;
    width: calc(33% - 35px);
    flex-shrink: 0;
    margin-bottom: 10px;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #faecdf;
    height: 44px;
    line-height: 44px;
    padding: 0 20px;
    color: #333333;
  }
}
</style>